import { Component, input, OnInit } from '@angular/core';

import { _FormModelService } from 'src/app/infrastructure/services/model-services/_form-model.service';
import { AccountFormModelService } from '../services/account-form-model.service';
import { AccountPageService } from '../services/account-page.service';
import { _CentralPageService } from '../../shared/central-page/services/_central-page.service';
import { ButtonNavigationComponent } from '../../shared/controls/container/button-navigation/button-navigation.component';
import { FooterService } from '../../shared/footer/footer.service';
import { IconsModule } from '../../shared/icons/icons.module';
import { IFooterData } from '../../shared/footer/models/footer-data';
import { IHeaderData } from '../../shared/header/models/header-data';
import { IPageData } from 'src/app/infrastructure/services/page-services/models/page-data';
import { PasswordChangeEditComponent } from './components/password-change-edit/password-change-edit.component';
import { SinglePageComponent } from '../../shared/central-page/container/single-page/single-page.component';
import { _SinglePageRouteComponent } from 'src/app/infrastructure/components/route-components/_single-page-route-component';
import { SinglePageService } from '../../shared/central-page/services/single-page.service';
import { pageTransitionAnimation } from 'src/app/infrastructure/animations/route-animations';
import { _PageService } from 'src/app/infrastructure/services/page-services/_page.service';
import { pageLayout, TPageLayout } from 'src/app/infrastructure/models/page-layout';
import { pageMode, TPageMode } from 'src/app/infrastructure/models/page-mode';
import { SectionButtonSave } from '../../shared/central-page/components/button-blocks/models/section-button-save';
import { ActivatedRouteService } from 'src/app/infrastructure/services/route-service/activated-route.service';
import { routePage } from 'src/app/infrastructure/services/route-service/models/route-page';
import { CLAIM_PAGE, ROUTE_PAGE } from 'src/app/infrastructure/injection-tokens/PAGE-NAME';
import { pageName } from 'src/assets/common/enums/page-name.g';

// Ingelogde losse pagina (vanuit het accountmenu in de header). Zelfde opbouw als Login/Register,
// maar zonder eigen ApplicationUserService (de root-instantie met de ingelogde gebruiker blijft gelden)
// en met een terug-knop in de footer, zoals ImageComponent. Start direct in edit-modus: het formulier
// staat in de edit-sectie, met de standaard save-/cancel-knop in de footer.
@Component({
    selector: 'app-password-change',
    templateUrl: './password-change.component.html',
    styleUrls: ['./password-change.component.scss'],
    standalone: true,
    imports: [
        ButtonNavigationComponent,
        IconsModule,
        PasswordChangeEditComponent,
        SinglePageComponent,
    ],
    providers: [
        {provide: ROUTE_PAGE, useValue: routePage.passwordChange},
        // Claim-pagina (Pages.PasswordChange): Page_Read/Page_Update + knop-claims (BtnPageSave_Show, ...).
        {provide: CLAIM_PAGE, useValue: pageName.passwordChange},
        ActivatedRouteService,
        AccountFormModelService,
        AccountPageService,
        FooterService,
        SinglePageService,
        {provide: _FormModelService, useExisting: AccountFormModelService},
        {provide: _CentralPageService, useExisting: SinglePageService},
        {provide: _PageService, useExisting: AccountPageService},
    ],
    animations: [
        pageTransitionAnimation
    ],
})
export class PasswordChangeComponent
    extends _SinglePageRouteComponent<null, null>
    implements OnInit
{
    // Model uit de route-resolver (eigen account + claims van deze pagina). Zonder recht (Page_Read)
    // wordt de navigatie al in de resolver geannuleerd, zie modelResolve$.
    protected resolver$$ = input<any>();

    // Services
    override readonly userClaimService = this._applicationUserService;
    override readonly activatedRouteService = this._activatedRouteService;
    override readonly centralPageService = this._centralPageService;
    override readonly footerService = this._footerService;
    override readonly formModelService = this._formModelService;
    override readonly loadingPageService = this._loadingPageService;
    override readonly loadingService = this._loadingService;
    override readonly pageService = this._pageService;
    override readonly reloadService = this._reloadService;

    // Data
    override headerData: Partial<IHeaderData> = {};
    override footerData: Partial<IFooterData> = {};
    override returnPage: IPageData | null = null;
    override btnCancelData = null;
    override btnDeleteData = null;
    override btnEditData = null;
    override btnSaveData = SectionButtonSave.create({tooltip: 'wachtwoord wijzigen'});
    override isStartPage = false;
    override pageCurrent_name = routePage.passwordChange;
    override pageLayout: TPageLayout = pageLayout.detailsPage;
    override pageMode_initial: TPageMode = pageMode.editPage;

    // Templates
    override readonly template_details$$ = this._template_details_viewChild$$;
    override readonly template_edit$$ = this._template_edit_viewChild$$;
    override readonly template_footerLeft$$ = this._template_footerLeft_viewChild$$;

    override ngOnInit(): void {
        // Account-pagina zonder domain-scope: de claims van deze pagina zijn app-niveau (dGuid null).
        // Expliciete null wint van de domainUserData-fallback in routeKeys (zie AdminPanel-resolver).
        this._activatedRouteService.routeKeys_set({ dauGuid: null, pamGuid: null });
        super._ngOnInit();
    }

    override emit_onEscape(): void {
        super._emit_onEscape();
    }

    override emit_onPageLoaded(): void {
        super._emit_onPageLoaded();
    }
}
